
<template>
  <div class="com-img" :style="imgWrapperStyle" @click="checkImage">
    <img class="com-img-item" v-hb-img.src="img" :style="imgStyle" alt="" @load="showImg">
  </div>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin'
import { executeProtocol } from '_lib/utils'
import { imgs_list } from './com-index'
export default {
  mixins: [CptMixin],
  data () {
    return {
      img: '',
      opacity: 0,
    }
  },
  mounted () {
    this.handleImgLoad()
  },
  methods: {
    handleImgLoad () {
      let top = this.getNodeOffsetTop(this.$el),
          cur_top = window.scrollY + window.innerHeight + 100
      if (this.dataInfo.index < 3 || cur_top > top) {
        this.setImgSrc()
      } else {
        imgs_list.push([top, this.setImgSrc])
      }
    },
    checkImage () {
      switch (this.articleInfo.source) {
        case 'share': break;
        case 'post': {
          executeProtocol({
            "protocol_type": "imagePreview",
            "image_urls": this.dataInfo.urls.join(","),
            "index": this.dataInfo.index
          })
          break
        }
      }
    },
    getNodeOffsetTop (node) {
      let cur = node, top = 0
      while (cur.tagName != 'BODY') {
        top += cur.offsetTop
        cur = cur.parentNode
      }
      return top
    },
    setImgSrc () {
      this.img = this.dataInfo.url
    },
    showImg () {
      setTimeout(() => {
        this.opacity = 1
      });
    }
  },
  computed: {
    imgStyle () {
      return {
        width: this.dataInfo.width + 'px',
        height: this.dataInfo.height + 'px',
        // margin: this.dataInfo.margin + 'px',
      }
    },
    imgWrapperStyle () {
      return {
        opacity: this.opacity
      }
    }
  }
}
</script>

<style lang="less">
.com-img {
  margin: 12px 0;
  transform: translate3d(0, 0, 0);
  .com-img-item {
    display: block;
    margin: 12px auto;
    border-radius: 4px;
    max-width: 100%;
    transition: opacity .4s;
  }
}
</style>